import Swiper from 'swiper/bundle';


if ($('.whats-on-slider').length) {
	window.whatsonSlider = new Swiper('.whats-on-slider', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoHeight: true,
		speed: 600,
		autoplay: false,
		navigation: false,
		scrollbar: false,
		pagination: {
			el: '.whats-on-slider-pagination',
			type: 'bullets',
			clickable: true,
		},
		loop: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            640: {
				slidesPerView: 1.8,
            },
            768: {
				slidesPerView: 2,
            },
            1024: {
				slidesPerView: 2.5,
            },
        },
        on: {
            init: function () {
                // console.log('swiper initialized');
                // var resultsSlider = $('.whats-on-slider');
                // resultsSlider.find('.card').parent().addClass('adjust-height');
            },
        },
	});
}


$('.relevant-slider-section').each(function() {
    var $sliderSection = $(this);
    var slidesPerView = $sliderSection.data('size') === "large" ? 3 : 4;
    // Setup for "shop" sliders
    var $shopTab = $sliderSection.find('[data-tab="shop"]');
    var $shopSlider = $sliderSection.find('.relevant-slider-shop');
    if ($shopSlider.length) {
        new Swiper($shopSlider[0], {
            slidesPerView: 1,
            spaceBetween: 16,
            autoHeight: true,
            speed: 600,
            autoplay: false,
            navigation: {
                nextEl: $shopTab.find('.swiper-button-next')[0],
                prevEl: $shopTab.find('.swiper-button-prev')[0],
            },
            pagination: {
                el: $shopSlider.find('.relevant-slider-shop-pagination')[0],
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                640: { slidesPerView: 1.8 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 2.5 },
                1280: { slidesPerView: slidesPerView, freeMode: { enabled: false, sticky: false }, autoHeight: false },
            },
            on: {
                init: function () {},
                resize: function () {
                    adjustButtonMargin($shopSlider, $shopTab);
                },
            },
        });
    }

    // Setup for "whatson" sliders
    var $whatsonTab = $sliderSection.find('[data-tab="whatson"]');
    var $whatsonSlider = $sliderSection.find('.relevant-slider-whatson');
    if ($whatsonSlider.length) {
        new Swiper($whatsonSlider[0], {
            slidesPerView: 1,
            spaceBetween: 16,
            autoHeight: true,
            speed: 600,
            autoplay: false,
            navigation: {
                nextEl: $whatsonTab.find('.swiper-button-next')[0],
                prevEl: $whatsonTab.find('.swiper-button-prev')[0],
            },
            pagination: {
                el: $whatsonSlider.find('.relevant-slider-whatson-pagination')[0],
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                640: { slidesPerView: 1.8 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 2.5 },
                1280: { slidesPerView: slidesPerView, freeMode: { enabled: true, sticky: false }, autoHeight: false },
            },
            on: {
                init: function () {},
                resize: function () {
                    adjustButtonMargin($whatsonSlider, $whatsonTab);
                },
            },
        });
    }

    // Helper function to adjust button margin
    function adjustButtonMargin($slider, $tabSection) {
        var marginTop = 20 + $slider.find('.image-container').first().height() / 2 - $tabSection.find('.swiper-button').first().height() / 2;
        if (marginTop > 20) {
            $tabSection.find('.swiper-button').css('margin-top', marginTop + 'px');
        }
    }
});

// var slidesPerView = $('.relevant-slider-section[data-size="large"]').length ? 3 : 4;

// var relevantSliderShopSection = $('.relevant-slider-section [data-tab="shop"]');
// var relevantSliderShop = $('.relevant-slider-shop');
// if (relevantSliderShop.length) {
// 	window.slider = new Swiper('.relevant-slider-shop', {
// 		slidesPerView: 1,
// 		spaceBetween: 16,
// 		autoHeight: true,
// 		speed: 600,
// 		autoplay: false,
// 		navigation: {
// 			nextEl: relevantSliderShopSection.find('.swiper-button-next')[0],
// 			prevEl: relevantSliderShopSection.find('.swiper-button-prev')[0],
// 		},
// 		scrollbar: false,
// 		pagination: {
// 			el: '.relevant-slider-shop-pagination',
// 			type: 'bullets',
// 			clickable: true,
// 		},
// 		freeMode: false,
// 		loop: false,
// 		touchEventsTarget: 'wrapper',
//         breakpoints: {
//             640: {
// 				slidesPerView: 1.8,
//             },
//             768: {
// 				slidesPerView: 2,
//             },
//             1024: {
// 				slidesPerView: 2.5,
//             },
//             1280: {
// 				slidesPerView: slidesPerView,
// 				freeMode: {
// 					enabled: false,
// 					sticky: false,
// 				},
// 				autoHeight: false,
//             },
//         },
//         on: {
//             init: function () {
//             },
//             resize: function () {
// 				var marginTop = 20 + relevantSliderShop.find('.image-container').first().height() / 2 - relevantSliderShopSection.find('.swiper-button').first().height() / 2;
// 				if (marginTop > 20) {
// 					relevantSliderShopSection.find('.swiper-button').css('margin-top', marginTop + 'px');
// 				}
//             },
//         },
// 	});
// }


// var relevantSliderWhatsonSection = $('.relevant-slider-section [data-tab="whatson"]');
// var relevantSliderWhatson = $('.relevant-slider-whatson');
// if (relevantSliderWhatson.length) {
// 	window.slider = new Swiper('.relevant-slider-whatson', {
// 		slidesPerView: 1,
// 		spaceBetween: 16,
// 		autoHeight: true,
// 		speed: 600,
// 		autoplay: false,
// 		navigation: {
// 			nextEl: relevantSliderWhatsonSection.find('.swiper-button-next')[0],
// 			prevEl: relevantSliderWhatsonSection.find('.swiper-button-prev')[0],
// 		},
// 		scrollbar: false,
// 		pagination: {
// 			el: '.relevant-slider-whatson-pagination',
// 			type: 'bullets',
// 			clickable: true,
// 		},
// 		freeMode: false,
// 		loop: false,
// 		touchEventsTarget: 'wrapper',
//         breakpoints: {
//             640: {
// 				slidesPerView: 1.8,
//             },
//             768: {
// 				slidesPerView: 2,
//             },
//             1024: {
// 				slidesPerView: 2.5,
//             },
//             1280: {
// 				slidesPerView: slidesPerView,
// 				freeMode: {
// 					enabled: true,
// 					sticky: false,
// 				},
// 				autoHeight: false,
//             },
//         },
//         on: {
//             init: function () {
//             },
//             resize: function () {
// 				var marginTop = 20 + relevantSliderWhatson.find('.image-container').first().height() / 2 - relevantSliderWhatsonSection.find('.swiper-button').first().height() / 2;
// 				if (marginTop > 20) {
// 					relevantSliderWhatsonSection.find('.swiper-button').css('margin-top', marginTop + 'px');
// 				}
//             },
//         },
// 	});
// }



var lessonsSliderD = $('.lessons-slider-desktop');
if (lessonsSliderD.length) {
	window.lessonsSliderD = new Swiper('.lessons-slider-desktop', {
		slidesPerView: 1.2,
		spaceBetween: 16,
		autoHeight: true,
		speed: 600,
		autoplay: false,
		navigation: false,
		scrollbar: false,
		pagination: false,
		loop: true,
		touchEventsTarget: 'wrapper',
		centeredSlides: false,
		freeMode: false,
		mousewheel: {
			releaseOnEdges: true,
			forceToAxis: true,
		},
        breakpoints: {
            1280: {
				slidesPerView: 3.5,
            },
            1696: {
				slidesPerView: 4,
            },
            1920: {
				slidesPerView: 4.5,
				loop: false,
				freeMode: {
					enabled: true,
					sticky: false,
				},
            },
        },
        on: {
            init: function () {
            },
            resize: function () {
            },
        },
	});
}


var lessonsSliderM = $('.lessons-slider-mobile');
if (lessonsSliderM.length) {
	window.lessonsSliderM = new Swiper('.lessons-slider-mobile', {
		slidesPerView: 1.2,
		spaceBetween: 16,
		autoHeight: true,
		speed: 600,
		autoplay: false,
		navigation: false,
		scrollbar: false,
		pagination: {
			el: '.lessons-slider-pagination',
			type: 'bullets',
			clickable: true,
		},
		loop: false,
		touchEventsTarget: 'wrapper',
		centeredSlides: true,
		freeMode: false,
		mousewheel: false,
        breakpoints: {
            480: {
				slidesPerView: 1.5,
            },
            640: {
				slidesPerView: 2.2,
				centeredSlides: false,
				slidesPerGroup: 2,
            },
            768: {
				slidesPerView: 2.8,
				centeredSlides: false,
				slidesPerGroup: 2,
            },
            1024: {
				slidesPerView: 3.5,
				centeredSlides: false,
				slidesPerGroup: 2,
            },
        },
        on: {
            init: function () {
            },
            resize: function () {
            },
        },
	});
}


var customSliderSection = $('.custom-slider-section');
var customSlider = $('.custom-slider');
if (customSlider.length) {
	window.slider = new Swiper('.custom-slider', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoHeight: true,
		speed: 600,
		autoplay: false,
		navigation: {
			nextEl: customSliderSection.find('.swiper-button-next')[0],
			prevEl: customSliderSection.find('.swiper-button-prev')[0],
		},
		scrollbar: false,
		pagination: {
			el: '.custom-slider-pagination',
			type: 'bullets',
			clickable: true,
		},
		freeMode: false,
		loop: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            640: {
				slidesPerView: 1.8,
            },
            768: {
				slidesPerView: 2,
            },
            1024: {
				slidesPerView: 2.5,
            },
            1280: {
				slidesPerView: 3,
				autoHeight: false,
            },
        },
        on: {
            init: function () {
                // console.log('swiper initialized');

				// customSlider.on('mousemove', function(event) {
				// 	var distanceToRightEdge = customSlider.width() - (event.pageX - customSlider.offset().left);
				// 	if (distanceToRightEdge <= 200) {
				// 		customSliderSection.find('.swiper-button-next').addClass('shown');
				// 	} else {
				// 		customSliderSection.find('.swiper-button-next').removeClass('shown');
				// 	}
				// 	var distanceToLeftEdge = event.pageX - customSlider.offset().left;
				// 	if (distanceToLeftEdge <= 200) {
				// 		customSliderSection.find('.swiper-button-prev').addClass('shown');
				// 	} else {
				// 		customSliderSection.find('.swiper-button-prev').removeClass('shown');
				// 	}
				// });
            },
            resize: function () {
				var marginTop = 20 + customSlider.find('.image-container').first().height() / 2 - customSliderSection.find('.swiper-button').first().height() / 2;
				if (marginTop > 20) {
					customSliderSection.find('.swiper-button').css('margin-top', marginTop + 'px');
				}
            },
        },
	});
}


var gallerySlider = $('.gallery-slider');
if (gallerySlider.length) {
	gallerySlider.each(function() {
		window.slider = new Swiper($(this)[0], {
			slidesPerView: 1,
			spaceBetween: 32,
			autoHeight: true,
			speed: 600,
			autoplay: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			freeMode: false,
			loop: false,
			touchEventsTarget: 'wrapper',
			on: {
				init: function () {
					// console.log('swiper initialized');

				},
				resize: function () {

				},
			},
		});
	});
}

var topicSlider = $('.slider-thumbnail');
if (topicSlider.length) {
	// Initialize multiple sliders and thumbnails
	$('.slider-thumbnail').each(function() {
		var sliderId = $(this).data('slider');
		var sliderClass = '.slider[data-slider="' + sliderId + '"]';

		var sliderThumbnail = new Swiper($(this)[0], {
			slidesPerView: 'auto',
			spaceBetween: 11,
			autoHeight: false,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
		});

		var slider = new Swiper('.slider[data-slider="' + sliderId + '"]', {
			navigation: false,
			autoHeight: true,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			thumbs: {
				swiper: sliderThumbnail
			}
		});
	});
}

var shopSliderSection = $('.product-info-section');
var shopSlider = $('.slider-thumbnail-shop');
if (shopSlider.length) {
	console.log(shopSliderSection.find('.swiper-button-next')[0])
	// Initialize multiple sliders and thumbnails
	$('.slider-thumbnail-shop').each(function() {
		var sliderId = $(this).attr('data-slider');

		var sliderThumbnail = new Swiper($(this)[0], {
			slidesPerView: 4,
			spaceBetween: 11,
			autoHeight: false,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
		});

		var slider = new Swiper('.slider-shop[data-slider="' + sliderId + '"]', {
			loop: true,
			navigation: {
				nextEl: shopSliderSection.find('.swiper-button-next')[0],
				prevEl: shopSliderSection.find('.swiper-button-prev')[0],
			},
			pagination: {
				el: '.shop-slider-pagination',
				type: 'bullets',
				clickable: true,
			},
			autoHeight: true,
			thumbs: {
				swiper: sliderThumbnail
			}
		});
	});
}

var mediaSlider = $('.slider-media');
if (mediaSlider.length) {
	mediaSlider.each(function() {
		var section = $(this).closest('section');
		console.log('section' + section)
		window.slider = new Swiper($(this)[0], {
			slidesPerView: 1,
			spaceBetween: 32,
			autoHeight: true,
			speed: 600,
			autoplay: false,
			pagination: {
				el: section.find('.media-slider-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: section.find('.swiper-button-next')[0],
				prevEl: section.find('.swiper-button-prev')[0],
			},
			freeMode: false,
			loop: false,
			touchEventsTarget: 'wrapper',
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
				resize: function () {

				},
				touchStart: function () {
					// Disable iframe interaction when the user starts dragging
					const activeSlide = this.slides[this.activeIndex];
					const iframe = activeSlide.querySelector('iframe');
					if (iframe) {
						iframe.style.pointerEvents = 'none';
					}
				},
				touchEnd: function () {
					// Re-enable iframe interaction when the user stops dragging
					const activeSlide = this.slides[this.activeIndex];
					const iframe = activeSlide.querySelector('iframe');
					if (iframe) {
						iframe.style.pointerEvents = 'auto';
					}
				}
			},
		});
	});
}

var announcementSlider = $('.swiper-announcements');
if (announcementSlider.length) {
	announcementSlider.each(function() {
		var nextEl = $(this).closest('aside').find('.swiper-button-next');
		var prevEl = $(this).closest('aside').find('.swiper-button-prev');
		window.slider = new Swiper($(this)[0], {
			slidesPerView: 1,
			spaceBetween: 20,
			autoHeight: true,
			speed: 600,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			pagination: false,
			centeredSlides: false,
			navigation: {
				nextEl: nextEl[0],
				prevEl: prevEl[0],
			},
			freeMode: false,
			loop: true,
			touchEventsTarget: 'wrapper',
			on: {
				init: function () {
					setMaxWidthForSwiper('.swiper-announcements');
					this.update();
				},
				resize: function () {
					setMaxWidthForSwiper('.swiper-announcements');
				},
			},
		});
	});
}
function setMaxWidthForSwiper(sliderSelector) {
    const $slider = $(sliderSelector);
    if (!$slider.length) return;

    let maxWidth = 0;

    $slider.find('.swiper-slide').each(function () {
        const slideWidth = $(this).find('div').outerWidth(true) + 100;
        if (slideWidth > maxWidth) {
            maxWidth = slideWidth;
        }
    });

    $slider.css('max-width', `${maxWidth}px`);
}